import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { UserPreferencesPasswordChangeComponent } from 'src/app/shared/components/user-preferences-password-change/user-preferences-password-change.component.ts';
import { UserPreferencesAccountComponent } from './user-preferences-account/user-preferences-account.component';
import { UserPreferencesNotificationsComponent } from './user-preferences-notifications/user-preferences-notifications.component';
import { UserPreferencesAccessCheckComponent } from './user-preferences-access-check/user-preferences-access-check.component';

downgradedAngularModule
  .directive('angularUserPreferencesAccount', downgradeComponent({ component: UserPreferencesAccountComponent }))
  .directive('angularUserPreferencesNotifications', downgradeComponent({ component: UserPreferencesNotificationsComponent }))
  .directive('angularUserPreferencesPasswordChange', downgradeComponent({ component: UserPreferencesPasswordChangeComponent }))
  .directive('angularUserPreferencesAccessCheck', downgradeComponent({ component: UserPreferencesAccessCheckComponent }))
  ;

